module.exports = __webpack_public_path__ + "static/media/2cirqueducelestetext.6cecad73.jpg";